export default __webpack_public_path__ + "static/media/juli 2023 avond met snackmobiel-1.5c22b955.jpg";